import React from 'react';
import {
    SecurityListHeaderColumn,
    SecurityListColumn
} from '../../../common';
import { constants } from '../../../../../constants';

export const isinCusip = {
    columnName: 'isinCusip',
    renderHeader: function (sortBy, sortDirection, onClick) {
        return (
            <SecurityListHeaderColumn
                key={this.columnName}
                className="data-list-cell-md"
                sorted={sortBy === this.columnName}
                sortDirection={sortDirection}
                onClick={onClick ? () => onClick(this.columnName) : null}
            >
                Identifier
            </SecurityListHeaderColumn>

        );
    },
    renderBody: function (position) {
        return (
            <SecurityListColumn key={this.columnName} className="data-list-cell-md">
                {position.isinCusip || constants.emptyPlaceholder}
            </SecurityListColumn>
        );
    }
};
